import React from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { calculateTotalExperience } from "../utils/functions";
const CoachCard = ({ coach, user, likeButton, defaultUserImage }) => {
  return (
    <div className="flex flex-col justify-between w-full h-full overflow-hidden bg-white rounded-lg shadow-lg">
      {/* Background Image */}
      <NavLink
            to={user ? `/browse-coach/coach-details/${coach.coach_id}` : "#"}
              onClick={(e) => {
                if (!user) {
                  e.preventDefault();
                  toast.error("Please login to do this action");
                }
              }}
              className="block h-full"
            >
      <div className="">
        <div className="relative w-full h-32 bg-gradient-to-r from-blue-500 to-blue-600">
          {coach?.background_img ? (
            <img
              src={`${process.env.REACT_APP_COACH_BG_FOLDER_PATH}${coach?.background_img}`}
              alt="Background"
              className="object-cover w-full h-full"
            />
          ) : (
            <div className="w-full h-full bg-gray-200">
              <img
                src={`https://i.pinimg.com/736x/2d/b9/26/2db9264d5cf335e222baa960c19586e8.jpg`}
                alt="Profile"
                className="object-cover w-full h-full"
                onError={defaultUserImage}
              />
            </div>
          )}
          <div className="absolute top-2 right-2">
            <span className="px-2 py-1 text-xs font-semibold text-white bg-green-500 rounded-full">
              Novice
            </span>
          </div>
        </div>

        {/* Profile Content */}
        <div className="w-full px-2 py-2 mx-auto text-center">
          {/* Profile Image */}
          <div className="w-16 h-16 mx-auto overflow-hidden border-4 border-white rounded-full mb- w-full3">
            {coach?.profile_pic ? (
              <img
                src={`${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${coach?.profile_pic}`}
                alt="Profile"
                className="object-cover w-full h-full"
                onError={defaultUserImage}
              />
            ) : (
              <div className="w-full h-full bg-gray-300">
                <img
                  src={`https://static.vecteezy.com/system/resources/previews/020/911/732/non_2x/profile-icon-avatar-icon-user-icon-person-icon-free-png.png`}
                  alt="Profile"
                  className="object-cover w-full h-full"
                  onError={defaultUserImage}
                />
              </div>
            )}
          </div>

          <h3 className="mb-1 text-lg font-bold">{coach.name}</h3>

          {/* Skills */}
          <div className="w-full mb-2">
            {coach?.skills?.map((skill, index) => (
              <span key={index} className="text-sm text-gray-600 opacity-70">
                {skill?.name}
                {index < coach.skills.length - 1 ? ", " : ""}
              </span>
            ))}
          </div>

          {/* Stats */}
          <div className="flex items-center justify-between w-full px-4 py-2 text-sm">
            <div className="flex items-center">
              <svg
                className="w-4 h-4 mr-1 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              <span>
                {/* {coach.workexperience > 0
                  ? `${coach.workexperience} Years`
                  : "0 Years"} */}
                {calculateTotalExperience(coach?.experiences)}
                  
              </span>
            </div>

            <div className="flex items-center">
              <svg
                className="w-4 h-4 mr-1 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <span>{coach.followers_count || 0}</span>
            </div>

            <div className="flex items-center">
              <svg
                className="w-4 h-4 mr-1 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="font-semibold text-blue-600">
                {coach?.programs?.length === 1
                  ? `$${coach.programs[0].price}`
                  : coach?.programs?.length > 1
                  ? `$${coach.programs[0].price} - $${
                      coach.programs[coach.programs.length - 1].price
                    }`
                  : ""}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Buttons */}
      <div className="flex w-full border-t border-gray-200">
        <button className="flex items-center justify-center flex-1 gap-2 py-3 text-white transition bg-[#139337] hover:bg-[#139337d7]">
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.41533 0.192057C7.42938 0.195333 6.69887 0.369148 6.20034 0.659662C5.69711 0.953247 5.40967 1.35431 5.28132 1.91611C4.95969 3.04027 5.84185 5.6813 6.85301 7.47323H1.945C0.896989 7.47323 0.28504 8.15295 0.0516543 9.04126C-0.0697502 10.1861 -0.0402685 10.9633 0.85134 11.8107C0.52623 12.2721 0.335009 12.8923 0.391723 13.3697C0.614265 14.0815 0.876114 14.3456 1.45797 14.6259C0.842142 15.9517 1.13634 16.8321 1.99109 17.5421C1.72454 18.593 2.03388 19.5245 2.54261 20.1373C2.90109 20.6471 3.78328 20.9404 4.36247 21.1734C6.60613 21.5641 8.3533 21.1341 10.3735 20.5865C11.714 20.2231 13.1764 19.8116 14.9414 19.5686V9.22475H14.2152C12.7279 7.5333 11.2274 5.85185 9.94151 4.40133C9.72163 3.43744 9.45691 2.46621 9.16027 1.64116C8.95881 1.11642 8.77435 0.589066 8.41588 0.192263L8.41533 0.192057ZM17.919 9.22455H15.5294V19.495C16.3385 19.4354 17.1701 19.3637 17.9005 19.3574C18.9152 19.4096 19.3638 18.7755 19.3711 17.9636V10.6732C19.3656 9.68293 18.7829 9.20227 17.919 9.22434V9.22455ZM17.8823 17.1475C18.3696 17.1475 18.7647 17.5416 18.7647 18.0278C18.7647 18.5141 18.3698 18.9082 17.8823 18.9082C17.3951 18.9082 17 18.5141 17 18.0278C17 17.5416 17.3951 17.1475 17.8823 17.1475Z"
              fill="currentColor"
            />
          </svg>
          <span>Interested</span>
        </button>

        <button
          className="flex items-center justify-center flex-1 gap-2 py-3 text-red-600 transition bg-white border-l border-gray-200 hover:bg-gray-100"
          onClick={!user ? (e) => likeButton(e) : null}
        >
          <svg
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5498 10.1587L20.7532 5.95535M20.7532 5.95535L16.5498 1.75195M20.7532 5.95535H7.09213C4.1903 5.95535 1.83789 8.30778 1.83789 11.2096C1.83789 14.1114 4.1903 16.4638 7.09213 16.4638H12.3464"
              stroke="currentColor"
              strokeWidth="1.73147"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Not Interested</span>
        </button>
      </div>
      </NavLink>
    </div>
  );
};

export default CoachCard;
